export const getInfamyTierLabel = (value: number): string => {
  if (value >= 1_000_000) return 'Emperor of the Sea';
  if (value >= 500_000) return 'Warlord';
  if (value >= 100_000) return 'Dread Captain';
  if (value >= 50_000) return 'Scourge';
  if (value >= 10_000) return 'Marauder';
  if (value >= 1_000) return 'Raider';
  return 'Deckhand';
};

export const getHeatLevel = (value: number): { level: number; label: string; color: string } => {
  if (value >= 1_000_000) return { level: 100, label: 'MAXIMUM', color: '#dc2626' };
  if (value >= 500_000) return { level: 85, label: 'EXTREME', color: '#ea580c' };
  if (value >= 100_000) return { level: 70, label: 'HIGH', color: '#f97316' };
  if (value >= 50_000) return { level: 55, label: 'ELEVATED', color: '#facc15' };
  if (value >= 10_000) return { level: 40, label: 'MODERATE', color: '#a3e635' };
  if (value >= 1_000) return { level: 25, label: 'LOW', color: '#22c55e' };
  return { level: 10, label: 'MINIMAL', color: '#10b981' };
};

export const getSecurityLabel = (tier: 'safe_zone' | 'contested' | 'open_waters', isDocked: boolean = false): string => {
  if (isDocked) return 'SAFE: DOCKED';
  if (tier === 'safe_zone') return 'SAFE: SAFE WATERS';
  if (tier === 'contested') return 'AT RISK: NAVY COVER';
  return 'MAX RISK: OPEN WATERS';
};

export const getSpaceLabel = (isInWhirlpool: boolean, isInRift: boolean, riftName?: string, riftAnomalyLevel?: number): string => {
  if (isInWhirlpool) return 'WHIRLPOOL';
  if (isInRift && riftName) {
    const anomalyLabel = riftAnomalyLevel ? ` [LV${riftAnomalyLevel}]` : '';
    return `RIFT: ${riftName.toUpperCase()}${anomalyLabel}`;
  }
  return 'WORLD';
};

export const getXpNeededForNext = (level: number): number => {
  return 100 * (level + 1) + 50 * (level + 1) * level;
};

export const isIslandResearched = (islandId: string): boolean => {
  try {
    const stored = localStorage.getItem('grandline_researched_islands');
    if (!stored) return false;
    const islands = JSON.parse(stored);
    return !!islands[islandId];
  } catch {
    return false;
  }
};
